import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import SharedPropsService from '../../../SharedPropsService';
import { ButtonTypeTokens, ColorTokens, IconTokens, SizeTypeTokens, WIDGET, } from '@voltmoney/schema';
import { isMobile } from '../../../configs/utils';
let disbursalAmount = 0;
export const CreateDisbursementRequest = async (action, _datastore, { network, navigate, setDatastore, showPopup, instrumentTrack }) => {
    if (disbursalAmount > 999) {
        instrumentTrack('WITHDRAW_CONFIRM_BUTTON_CLICKED');
        await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'continue', {
            loading: true,
        });
        await network
            .post(api.lmsDisbursalV2, {
            creditId: (await SharedPropsService.getUser()).linkedCredits[0].creditId,
            disbursalAmount: disbursalAmount,
        }, { headers: await getAppHeader(), handleFromMF: true })
            .then(async (response) => {
            if (response?.status === 200) {
                const noOfOtpDigits = response?.data?.noOfDigits;
                await navigate(ROUTE.WITHDRAWAL_OTP, {
                    disbursalAmount: disbursalAmount,
                    accountNumber: action.payload.accountNumber,
                    noOfOtpDigits: noOfOtpDigits
                });
            }
            if (response?.response?.status === 400) {
                if (response?.response?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP') {
                    const errorMessage = response?.response?.data?.message;
                    showPopup({
                        title: errorMessage,
                        type: 'FAILED',
                        ctaLabel: 'Go back',
                        ctaAction: {
                            routeId: ROUTE.ALERT_PAGE,
                            type: ACTION.CLOSE_POPUP,
                            payload: {}
                        },
                        primary: true
                    });
                }
            }
        });
        await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'continue', {
            loading: false,
        });
    }
    else {
        await showPopup({
            title: 'Withdrawal amount must be more than ₹1,000',
            type: 'DEFAULT',
            iconName: IconTokens.Alert,
            ctaLabel: 'OK',
        });
    }
};
export const goBack = async (action, _datastore, { goBack, navigate }) => {
    await goBack();
};
export const SetRecommendedAmount = async (action, _datastore, { setDatastore, removeWidgets }) => {
    await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'amountItem', {
        value: action.payload.value,
    });
    await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'continue', {
        type: ButtonTypeTokens.LargeFilled,
    });
    await removeWidgets(ROUTE.WITHDRAW_AMOUNT, [
        { id: 'amountMessage', type: WIDGET.MESSAGE },
        { id: 'amountSpace', type: WIDGET.SPACE },
    ]);
};
export const priceInWords = price => {
    const sglDigit = [
        'Zero',
        'One',
        'Two',
        'Three',
        'Four',
        'Five',
        'Six',
        'Seven',
        'Eight',
        'Nine',
    ], dblDigit = [
        'Ten',
        'Eleven',
        'Twelve',
        'Thirteen',
        'Fourteen',
        'Fifteen',
        'Sixteen',
        'Seventeen',
        'Eighteen',
        'Nineteen',
    ], tensPlace = [
        '',
        'Ten',
        'Twenty',
        'Thirty',
        'Forty',
        'Fifty',
        'Sixty',
        'Seventy',
        'Eighty',
        'Ninety',
    ], handle_tens = function (dgt, prevDgt) {
        return 0 == dgt
            ? ''
            : ' ' + (1 == dgt ? dblDigit[prevDgt] : tensPlace[dgt]);
    }, handle_utlc = function (dgt, nxtDgt, denom) {
        return ((0 != dgt && 1 != nxtDgt ? ' ' + sglDigit[dgt] : '') +
            (0 != nxtDgt || dgt > 0 ? ' ' + denom : ''));
    };
    let str = '', digitIdx = 0, digit = 0, nxtDigit = 0, words = [];
    if (((price += ''), isNaN(parseInt(price))))
        str = '';
    else if (parseInt(price) > 0 && price.length <= 10) {
        for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--)
            switch (((digit = price[digitIdx] - 0),
                (nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0),
                price.length - digitIdx - 1)) {
                case 0:
                    words.push(handle_utlc(digit, nxtDigit, ''));
                    break;
                case 1:
                    words.push(handle_tens(digit, price[digitIdx + 1]));
                    break;
                case 2:
                    words.push(0 != digit
                        ? ' ' +
                            sglDigit[digit] +
                            ' Hundred' +
                            (0 != price[digitIdx + 1] &&
                                0 != price[digitIdx + 2]
                                ? ' and'
                                : '')
                        : '');
                    break;
                case 3:
                    words.push(handle_utlc(digit, nxtDigit, 'Thousand'));
                    break;
                case 4:
                    words.push(handle_tens(digit, price[digitIdx + 1]));
                    break;
                case 5:
                    words.push(handle_utlc(digit, nxtDigit, 'Lakh'));
                    break;
                case 6:
                    words.push(handle_tens(digit, price[digitIdx + 1]));
                    break;
                case 7:
                    words.push(handle_utlc(digit, nxtDigit, 'Crore'));
                    break;
                case 8:
                    words.push(handle_tens(digit, price[digitIdx + 1]));
                    break;
                case 9:
                    words.push(0 != digit
                        ? ' ' +
                            sglDigit[digit] +
                            ' Hundred' +
                            (0 != price[digitIdx + 1] ||
                                0 != price[digitIdx + 2]
                                ? ' and'
                                : ' Crore')
                        : '');
            }
        str = words.reverse().join('');
    }
    else
        str = '';
    return str ? (parseInt(price) === 1 ? 'Rupee' + str : 'Rupees' + str) : str;
};
export const OnAmountChange = async (action, _datastore, { setDatastore, appendWidgets, removeWidgets }) => {
    disbursalAmount = parseFloat(action.payload.value);
    const user = await SharedPropsService.getUser();
    const availableCreditAmount = user.linkedCredits[0].availableCreditAmount;
    const recommendedAmount = 0.9 * availableCreditAmount;
    if (action.payload.value.length > 0 &&
        parseFloat(action.payload.value) <= availableCreditAmount) {
        await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'continue', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
    const currentApplicableInterestRate = user.linkedCredits[0].currentApplicableInterestRate;
    const monthlyInterest = Math.round(((disbursalAmount * currentApplicableInterestRate) / 1200) * 100) / 100;
    await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'interestItem', {
        value: `${monthlyInterest || 0}`,
    });
    if (disbursalAmount > availableCreditAmount) {
        await appendWidgets(ROUTE.WITHDRAW_AMOUNT, {
            amountMessage: {
                label: `Amount available for withdrawal is ₹${availableCreditAmount}. Enter a lower amount.`,
                color: ColorTokens.Red_50,
            },
            amountSpace: { size: SizeTypeTokens.XL },
        }, [
            {
                id: 'amountMessage',
                type: WIDGET.TEXT,
                padding: { top: 40 },
            },
            { id: 'amountSpace', type: WIDGET.SPACE },
        ], 'amountMsgSpace');
    }
    else {
        await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'amountMessage', null);
        await removeWidgets(ROUTE.WITHDRAW_AMOUNT, [
            { id: 'amountMessage', type: WIDGET.MESSAGE },
            { id: 'amountSpace', type: WIDGET.SPACE },
        ]);
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
let counter = 0;
export const amountConfirm = async (action, _datastore, { navigate, network, setDatastore, showPopup }) => {
    await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
        showErrorModal: false,
        currentErrorType: '',
        loading: true,
    });
    const disbursalAmount = action?.payload?.withdrawlValue;
    const isFirstJourney = action?.payload?.isFirstJourney;
    const response = await network.post(api.getWithdrawlDetails, {
        creditId: (await SharedPropsService.getUser()).linkedCredits[0].creditId,
        disbursalAmount,
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
            showErrorModal: false,
            currentErrorType: '',
            loading: false,
            counter: counter++,
        });
        await navigate(ROUTE.CONFIRM_AMOUNT, {
            withdrawResponse: response?.data,
            disbursalAmount,
            isFirstJourney,
            counter: counter++,
        });
    }
    else if (response?.response?.status === 400) {
        const { message = 'Something went wrong', voltErrorCode, header = 'Verification failed!' } = response?.response?.data;
        if (voltErrorCode === 'AMOUNT_LESS_THAN_MINIMUM_AND_FEES') {
            await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
                showErrorModal: true,
                currentModalHeight: isMobile() ? 288 : 270,
                loading: false,
                message,
                currentErrorType: 'AMOUNT_LESS_THAN_MINIMUM_AND_FEES',
                counter: counter++,
            });
        }
        else if (voltErrorCode === 'AMOUNT_LESS_THAN_MINIMUM') {
            await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
                showErrorModal: true,
                currentModalHeight: 270,
                loading: false,
                message,
                currentErrorType: 'AMOUNT_LESS_THAN_MINIMUM',
                counter: counter++,
            });
        }
        else if (voltErrorCode === 'AMOUNT_MORE_THAN_AVAILABLE') {
            await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
                showErrorModal: true,
                currentModalHeight: isMobile() ? 288 : 270,
                currentErrorType: 'AMOUNT_MORE_THAN_AVAILABLE',
                loading: false,
                message,
                counter: counter++,
            });
        }
        else {
            await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
                showErrorModal: true,
                currentModalHeight: 288,
                loading: false,
                header,
                message,
                counter: counter++,
            });
        }
    }
    else {
        await showPopup({
            title: 'Something went wrong',
            type: 'DEFAULT',
            iconName: IconTokens.Alert,
            ctaLabel: 'OK',
        });
    }
};
export const closeErrorModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
        showErrorModal: false,
        currentErrorType: '',
        showInfoModal: false,
        counter: counter++,
    });
};
export const fecthMinAmountDetails = async (action, _datastore, { setDatastore, network }) => {
    const disbursalAmount = action?.payload?.withdrawlValue;
    const response = await network.post(api.getminAmountDetails, {
        creditId: (await SharedPropsService.getUser()).linkedCredits[0].creditId,
        disbursalAmount,
    }, { headers: await getAppHeader() });
    const gstOnProcessingFee = response?.data?.gstOnProcessingFee;
    const accountOpeningFee = response?.data?.accountOpeningFee;
    const processingFee = response?.data?.processingFee;
    const stampDutyFee = response?.data?.stampDutyFee;
    const lienMarkingFee = response?.data?.lienMarkingFee;
    const modalHeight = (lienMarkingFee !== null && lienMarkingFee !== undefined) ? (isMobile() ? 390 : 364) : (isMobile() ? 356 : 338);
    await setDatastore(ROUTE.WITHDRAW_AMOUNT, 'withdrawAmountScreen', {
        showErrorModal: false,
        currentModalHeight: modalHeight,
        GST: gstOnProcessingFee,
        accountFee: accountOpeningFee,
        processingFee,
        stampDutyFee,
        lienMarkingFee,
        counter: counter++,
    });
};
